import CoreAnalytics from './coreAnalytics';

class RecordHealthAnalytics extends CoreAnalytics {
  EVENT_NAMES = {
    RECORD_HEALTH_VIEWED: 'record_health_viewed',
    FIELDS_SEARCHED: 'record_health_fields_searched',
    FIELDS_SORTED: 'record_health_fields_sorted',
    FIELD_COUNTED_CHANGED: 'record_health_field_counted_changed',
    UPDATE_CLIENT_DATA_VIEWED: 'update_client_data_viewed',
  };

  UPDATE_CLIENT_DATA_ENTRY_POINTS = {
    SIDEBAR: 'sidebar',
    BUTTON: 'button',
  };

  /**
   * @param {number|null} [activeClientCount] - Null when the reader has no clinic roster.
   * @returns {void}
   */
  trackRecordHealthViewed(activeClientCount = null) {
    this.track(this.EVENT_NAMES.RECORD_HEALTH_VIEWED, {
      activeClientCount,
      eventVersion: 1,
    });
  }

  /**
   * @param {number} matchedFieldCount - Rows left after the search. The term itself is never sent.
   * @param {number} totalFieldCount - Rows before it.
   * @returns {void}
   */
  trackFieldsSearched(matchedFieldCount, totalFieldCount) {
    this.track(this.EVENT_NAMES.FIELDS_SEARCHED, {
      matchedFieldCount,
      totalFieldCount,
      eventVersion: 1,
    });
  }

  /**
   * @param {string} column - 'field' or 'percent'.
   * @param {string} direction - 'asc' or 'desc'.
   * @returns {void}
   */
  trackFieldsSorted(column, direction) {
    this.track(this.EVENT_NAMES.FIELDS_SORTED, {
      column,
      direction,
      eventVersion: 1,
    });
  }

  /**
   * @param {string} field - A built-in field id, or 'customField'. A custom field's id and label
   *   are the clinic's own data, so neither is sent.
   * @param {boolean} isCounted - Whether it now counts toward the score.
   * @param {number} countedFieldCount - Fields counted after the change.
   * @returns {void}
   */
  trackFieldCountedChanged(field, isCounted, countedFieldCount) {
    this.track(this.EVENT_NAMES.FIELD_COUNTED_CHANGED, {
      field,
      isCounted,
      countedFieldCount,
      eventVersion: 1,
    });
  }

  /**
   * Fires once per visit to Update client data.
   *
   * @param {string} entryPoint - How the reader got there: 'button' from Record health's own
   *   button, 'sidebar' from the menu entry or any other route in.
   * @returns {void}
   */
  trackUpdateClientDataViewed(entryPoint) {
    this.track(this.EVENT_NAMES.UPDATE_CLIENT_DATA_VIEWED, {
      entryPoint,
      eventVersion: 1,
    });
  }
}

export default new RecordHealthAnalytics();
